import { Primitive } from 'ts-essentials';

export type Json<T> = string & { __value: T }
export type JsonValue<T> = T extends {
  __value: infer U
} ? U : never


export const jsonParseSafe = <Value extends Primitive | Record<string, unknown>| unknown[]>(
  json: Json<Value> | Primitive,
  defaultValue: Value |(() => Value)
): Value => {
  const getDefaultValue = () => {
    if (typeof defaultValue === 'function') {
      return defaultValue();
    }
    return defaultValue;
  };

  if (typeof json !== 'string') {
    return getDefaultValue();
  }

  try {
    return JSON.parse(json) ?? getDefaultValue();
  } catch (error) {
    return getDefaultValue();
  }
};

export function parseJsonStringOrNull<T = unknown>(raw: string | null | undefined): T | null {
  if (typeof raw !== 'string' || raw === '') {
    return null;
  }
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function parseJsonStringOrFallback<T>(raw: string | null | undefined, fallback: T): T {
  if (typeof raw !== 'string' || raw === '') {
    return fallback;
  }
  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}
